import { isEmpty } from "lodash";
import { LOCAL_ACCOUNTS_URL } from "./const";

export function getAccountsUrl() {
  const REACT_ENV = import.meta.env.VITE_HOST_ENV;
  const ACCOUNTS_URL = !!import.meta.env.VITE_ACCOUNTS_URL && import.meta.env.VITE_ACCOUNTS_URL !== "" ? import.meta.env.VITE_ACCOUNTS_URL : LOCAL_ACCOUNTS_URL;
  if (!isEmpty(REACT_ENV)) {
    return ACCOUNTS_URL;
  } else {
    return LOCAL_ACCOUNTS_URL;
  }
}
